import {registerReactPartial} from '@github-ui/react-core/register-partial'

import {GlobalUserNavDrawer} from './GlobalUserNavDrawer'

registerReactPartial('global-user-nav-drawer', {
  Component: GlobalUserNavDrawer,
})
